import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as Material from '@angular/material';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    Material.MatToolbarModule,
    Material.MatGridListModule,
    Material.MatFormFieldModule,
    Material.MatInputModule,
    Material.MatDatepickerModule,
    Material.MatNativeDateModule,
    Material.MatButtonModule,
    Material.MatCheckboxModule,
    Material.MatRadioModule,
    Material.MatCardModule,
    Material.MatOptionModule,
    Material.MatSelectModule,
    Material.MatIconModule,
    Material.MatSidenavModule,
    Material.MatListModule,
    Material.MatMenuModule,
    Material.MatTabsModule,
    Material.MatButtonToggleModule,
    Material.MatTableModule,
    Material.MatPaginatorModule,
    Material.MatSortModule,
    Material.MatSlideToggleModule,
    Material.MatTooltipModule,
    Material.MatTooltipModule,
    Material.MatSnackBarModule,
  ],
  exports: [
    Material.MatToolbarModule,
    Material.MatGridListModule,
    Material.MatFormFieldModule,
    Material.MatInputModule,
    Material.MatDatepickerModule,
    Material.MatNativeDateModule,
    Material.MatButtonModule,
    Material.MatCheckboxModule,
    Material.MatRadioModule,
    Material.MatCardModule,
    Material.MatOptionModule,
    Material.MatSelectModule,
    Material.MatIconModule,
    Material.MatSidenavModule,
    Material.MatListModule,
    Material.MatMenuModule,
    Material.MatTabsModule,
    Material.MatButtonToggleModule,
    Material.MatTableModule,
    Material.MatPaginatorModule,
    Material.MatSortModule,
    Material.MatSlideToggleModule,  
    Material.MatTooltipModule,
    Material.MatSnackBarModule,
  ]
})
export class MaterialModule { }
